import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import Slider from 'rc-slider';
import { ReduxFormField } from 'components';

import 'rc-slider/assets/index.css';

class renderField extends PureComponent {
  componentDidMount() {
    const { input, defaultValue } = this.props;

    if (typeof defaultValue !== 'undefined' && (typeof input.value === 'undefined' || input.value === '')) {
      input.onChange(defaultValue);
    }
  }

  render() {
    const { input, refPass, isRange, ...rest } = this.props;

    if (!!isRange) {
      return (
        <Form.Field>
          <Slider.Range
            name={rest.name}
            ref={refPass}
            onChange={e => {
              input.onChange(e);
            }}
            {...rest}
            // {...input}
          />
        </Form.Field>
      );
    } else {
      return (
        <Form.Field>
          <Slider
            min={10}
            max={100}
            name={rest.name}
            ref={refPass}
            onChange={e => {
              input.onChange(Number(e));
            }}
            {...rest}
            // {...input}
          />
        </Form.Field>
      );
    }
  }
}

const ReduxFormSlider = ({ ...rest }) => {
  return <ReduxFormField component={renderField} {...rest} />;
};

ReduxFormSlider.propTypes = {};
ReduxFormSlider.defaultProps = {};

export default ReduxFormSlider;



// WEBPACK FOOTER //
// ./src/script/components/reduxForm/ReduxFormSlider.js